import { useCallback } from "react";
import { CheckableItem, FilterSection } from "@vms/SelectFilters/SelectFiltersTypes";
import { useFilters } from "@vms/SelectFilters/SelectFiltersContext";

export function useCheckboxGroupChange() {
    const { filters, setPartial } = useFilters();

    return useCallback((
        section: FilterSection,
        groupName: string,
        id: number | 'all',
        isGroup?: boolean
    ) => {
        const sectionData = filters[section];
        const group = (sectionData as Record<string, unknown>)[groupName] as CheckableItem[] | undefined;

        if (!group || !Array.isArray(group)) return;

        let updatedGroup: CheckableItem[];
        if (id === 'all') {
            const allChecked = group.every(item => item.isChecked);
            updatedGroup = group.map(item => ({ ...item, isChecked: !allChecked }));
        } else if (isGroup) {
            const groupItems = group.filter(item => item.groupId === id);
            const allGroupChecked = groupItems.every(item => item.isChecked);
            updatedGroup = group.map(item => ({
                ...item,
                isChecked: item.groupId === id ? !allGroupChecked : item.isChecked,
            }));
        } else {
            updatedGroup = group.map(item =>
                item.id === id ? { ...item, isChecked: !item.isChecked } : item
            );
        }

        setPartial({
            [section]: {
                ...sectionData,
                [groupName]: updatedGroup,
            },
        });
    }, [filters, setPartial]);
}